/**
 * 入力画面のキーボードの操作（Issue #470。PC 用の並べ方のときだけ）。**キーの一次情報はこの表**（画面の説明もここから引く）。
 * 入力欄（数値・文字・選択・シークのつまみ）にフォーカスがあるときは奪わない。
 */
export const KEYMAP = [
  { combo: 'Space', action: 'toggle', label: '再生 / 停止' },
  { combo: 'ArrowLeft', action: 'back5', label: '−5 秒' },
  { combo: 'ArrowRight', action: 'fwd5', label: '+5 秒' },
  { combo: 'Shift+ArrowLeft', action: 'back1', label: '−1 秒' },
  { combo: 'Shift+ArrowRight', action: 'fwd1', label: '+1 秒' },
  { combo: 'ArrowUp', action: 'prevSpeech', label: '前の発話' },
  { combo: 'ArrowDown', action: 'nextSpeech', label: '次の発話' },
  { combo: 'KeyF', action: 'toggleSpeech', label: '今の発話の採否' },
  { combo: 'End', action: 'last', label: '最後の応答へ' },
  { combo: 'Mod+KeyZ', action: 'undo', label: '戻す' },
];

const EDITABLE = new Set(['INPUT', 'TEXTAREA', 'SELECT']);
export const isEditable = (el) => !!el && (EDITABLE.has(el.tagName) || el.isContentEditable === true);

/** キーの組み合わせの名前（e.code から。Ctrl と ⌘ は Mod にまとめる） */
export function comboOf(e) {
  const parts = [];
  if (e.ctrlKey || e.metaKey) parts.push('Mod');
  if (e.altKey) parts.push('Alt');
  if (e.shiftKey) parts.push('Shift');
  parts.push(e.code);
  return parts.join('+');
}

/** この keydown が指す操作（無ければ null）。入力欄の中・IME の変換中は null */
export function actionOf(e) {
  if (e.isComposing || isEditable(e.target)) return null;
  const combo = comboOf(e);
  return KEYMAP.find((k) => k.combo === combo)?.action ?? null;
}

const KEY_LABEL = { Space: 'Space', ArrowLeft: '←', ArrowRight: '→', ArrowUp: '↑', ArrowDown: '↓', End: 'End', KeyF: 'F', KeyZ: 'Z', Mod: 'Ctrl', Shift: 'Shift' };
export const comboLabel = (combo) => combo.split('+').map((p) => KEY_LABEL[p] ?? p).join('+');
/** 画面に出す説明（1 行） */
export const keymapHelp = () => KEYMAP.map((k) => `${comboLabel(k.combo)} ${k.label}`).join(' ・ ');
